import { IMakeRequest } from '../utils/make_request';
import { mergeBaseUri } from '@cian/http-api/shared';

export interface IPostReviewFormResponse200 {
  data: {
    isUserRegistered: boolean;
    logOnData: {
      logOnInfo: [
        {
          logOnUrl: string;
          token: string;
        }
      ];
      login: string;
    } | null;
  };
  status: 'ok';
}

export interface IPostReviewFormResponse404 {
  status: 'notFound';
}

export type TPostReviewFormResponse = IPostReviewFormResponse200 | IPostReviewFormResponse404;

export interface IPostReviewFormParameters {
  offerId: number;
  message: string;
  firstName: string;
  email: string;
  phoneNumber: string;
  captcha: string;
  subscribeForNews: boolean;
}

export function postReviewForm(
  makeRequest: IMakeRequest,
  apiBaseUrl: string,
  parameters: IPostReviewFormParameters,
): Promise<TPostReviewFormResponse> {
  return makeRequest({
    body: JSON.stringify({
      captcha: parameters.captcha,
      contacts: {
        email: parameters.email,
        firstName: parameters.firstName,
        phoneNumber: parameters.phoneNumber,
      },
      deviceType: 'desktop',
      isSubscribeNews: parameters.subscribeForNews,
      message: parameters.message,
      offerInfo: {
        offerId: parameters.offerId,
      },
      type: 'additionalInfoRequest',
    }),
    headers: [
      ['Content-Type', 'application/json'],
    ],
    method: 'POST',
    uri: mergeBaseUri(apiBaseUrl, {
      path: '/cian-api/messages/v1/message/',
    }),
  })
  .then((response) => {
    if (![200, 404].includes(response.responseStatusCode)) {
      throw new Error('Unexpected response status code');
    }

    return JSON.parse(response.responseBody);
  });
}
